import { render, staticRenderFns } from "./codeModal.vue?vue&type=template&id=231f4d89"
import script from "./codeModal.vue?vue&type=script&lang=js"
export * from "./codeModal.vue?vue&type=script&lang=js"
import style0 from "./codeModal.vue?vue&type=style&index=0&id=231f4d89&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports